import client from "./node-client.js";
import { createInstance } from "./node-client.js";
import * as index from "../../../analytics-types/lib/esm/index.js";
import { Revenue } from "../../../analytics-core/lib/esm/revenue.js";
import { Identify } from "../../../analytics-core/lib/esm/identify.js";
var add = client.add, groupIdentify = client.groupIdentify, identify = client.identify, init = client.init, logEvent = client.logEvent, remove = client.remove, revenue = client.revenue, setGroup = client.setGroup, setOptOut = client.setOptOut, track = client.track, flush = client.flush;
export {
  Identify,
  Revenue,
  index as Types,
  add,
  createInstance,
  flush,
  groupIdentify,
  identify,
  init,
  logEvent,
  remove,
  revenue,
  setGroup,
  setOptOut,
  track
};
//# sourceMappingURL=index.js.map
